import React, { useEffect, useState } from 'react';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';
import { useEffectAsync } from '../../../../helpers';
import NotificationsSidebar from '../NotificationsSidebar/NotificationsSidebar';
import { useLazyUnreadNotificationQuery } from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';

// @ts-ignore
import styles from './NotificationsButton.module.scss';

interface Props {
	userId: string;
}

const NotificationsButton: React.FC<Props> = props => {
	const [sidebarOpened, setSidebarOpened] = useState<boolean>(false);
	const [unreadCount, setUnreadCount] = useState<number>(0);
	const [getUnreadNotification] = useLazyUnreadNotificationQuery();
	const { socket } = useAppContext();

	const handleToggleSidebar = () => {
		setSidebarOpened(prevState => !prevState);
	};

	const updateUnreadCount = async () => {
		const { userNotice } = await getUnreadNotification().unwrap();
		setUnreadCount(userNotice?.unreadNotifications || 0);
	};

	const handleNotificationEvent = (data: {
		type: string;
		unread: string | undefined;
	}) => {
		const { type, unread } = data;
		if (data?.type === 'notification') {
			if (typeof data?.unread !== 'undefined') {
				setUnreadCount(parseInt(data.unread));
			} else {
				updateUnreadCount();
			}
		}
	};

	useEffectAsync(async () => {
		await updateUnreadCount();

		socket.on('message', handleNotificationEvent);
		return () => {
			socket.off('message', handleNotificationEvent);
		};
	});

	return (
		<div className={styles.wrapper}>
			<Tooltip
				trigger={
					<div onClick={handleToggleSidebar} className={styles.toggleButton}>
						<img width='16px' src='/dist/icons/bell.svg' alt='bell' />
						{unreadCount > 0 && (
							<span className={styles.badge}>{unreadCount}</span>
						)}
					</div>
				}>
				<Text tx={'base.notifications.title'} />
			</Tooltip>
			<NotificationsSidebar
				opened={sidebarOpened}
				onClose={handleToggleSidebar}
				onUpdate={updateUnreadCount}
			/>
		</div>
	);
};

export default NotificationsButton;
